import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import sanitizeHtml from "sanitize-html";
import ReactHtmlParser from "react-html-parser";
import { Link, useHistory, useParams } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import { validatePassword } from "../../../constants/Validation";
import ForgotPasswordAPI from "../../../services/ForgotPassword/ForgotPassword";
import { getCookie } from "../../../helpers/Cookie";

const forgotPasswordApi = new ForgotPasswordAPI();

const SetPassword = () => {
  const history = useHistory();
  const { code } = useParams();
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);

  useEffect(() => {
    // check token is available then redirect to dashboard page.
    const token = getCookie("token");
    if (token) {
      history.push("/dashboard/crm");
    }
    //eslint-disable-next-line
  }, []);

  // set password form finish
  const onSetPasswrod = async (fieldValues) => {
    try {
      setIsSubmitBtnLoading(true);

      let tempNewPass = ReactHtmlParser(
        sanitizeHtml(fieldValues["new-password"]),
      );
      let tempConfirmPass = ReactHtmlParser(
        sanitizeHtml(fieldValues["confirm-password"]),
      );

      if (tempNewPass[0] !== "" && tempConfirmPass[0] !== "") {
        const payload = {
          newPassword: tempNewPass[0],
          newConfirmPassword: tempConfirmPass[0],
          code: code,
        };
        const response = await forgotPasswordApi.verifyForgotPasswordCode(
          JSON.stringify(payload).replace(/</g, "\\u003c"),
        );
        if (response && response.data) {
          if (response.data.isUpdate) {
            message.success("Your password has been set successfully.");
            history.push("/login");
          } else {
            if(response.data.message === "Invalid confirmation code.") {
              message.error("Link is expired.");
            } else {
              message.error("Invalid data.");
            }
          }
        } else {
          message.error("Something went wrong! Please try again later.");
        }
      } else {
        message.error("Invalid data. Please put valid data in the fields.");
      }
    } catch (error) {
      message.error("Something went wrong! Please try again later.");
    } finally {
      setIsSubmitBtnLoading(false);
    }
  };

  // validate space key
  const validateSpaceLey = (values) => {
    // avoid space
    if (values.keyCode === 32) {
      values.preventDefault();
    }
  };

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-login-container">
        <div className="gx-login-content forgot-password-content">
          <div className="gx-login-header gx-text-center">
            <h1 className="gx-login-title">Set New Password</h1>
          </div>

          <Form
            initialValues={{ remember: true }}
            name="set-password"
            onFinish={onSetPasswrod}
            className="gx-signin-form gx-form-row0"
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              className="custom-form-item"
              label={
                <span>
                  New Password : <span style={{ color: "red" }}>*</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: (
                    <span className="custom-error-message">
                      Please enter new password.
                    </span>
                  ),
                },
                {
                  validator: validatePassword,
                },
              ]}
              hasFeedback
              name="new-password"
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="New password"
                onKeyDown={(e) => validateSpaceLey(e)}
              />
            </Form.Item>
            <Form.Item
              className="custom-form-item"
              label={
                <span>
                  Confirm Password : <span style={{ color: "red" }}>*</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: (
                    <span className="custom-error-message">
                      Please enter confirm password.
                    </span>
                  ),
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue("new-password") === value) {
                      return Promise.resolve();
                    }
                    if (value.length >= 8) {
                      return Promise.reject(
                        <span className="custom-error-message">
                          New password and confirm new password field do not match.
                        </span>,
                      );
                    }
                  },
                }),
              ]}
              hasFeedback
              name="confirm-password"
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Confirm password"
                onKeyDown={(e) => validateSpaceLey(e)}
              />
            </Form.Item>

            <Form.Item className="signin-bottom-links">
              <Button
                type="primary"
                className="gx-mb-0"
                htmlType="submit"
                loading={isSubmitBtnLoading}
              >
                Save
              </Button>
              <Link to="/login">Login</Link>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
